import {usePermissions} from "../../../resources/PermissionsHook";
import {FC, useState} from "react";
import {useToasts} from "@jane/lib/src/toasts/toasts";
import {SettingMap, useApiCall, useApiEndpoint} from "@jane/lib/src/api";
import {config} from "../../../config";
import {Card} from "@jane/lib/src/components/Card";
import { SettingsContainer } from "../SettingsPage";
import {Button} from "@jane/lib/src/components/form/Button";
import {Input} from "@ventumsoftware/react-toolkit";

export const CachePreferences: FC<{settings?: SettingMap, onUpdated?: () => Promise<void> }> = (props) => {
  const { canManageCache, canManageAppPreferences } = usePermissions()
  if (! canManageCache) {
    return <></>
  }

  return <SettingsContainer title={"Applicatie cache"} description={"Om de snelheid van Jane te verhogen wordt veel-opgevraagde informatie gecachet. Soms kan het wenselijk zijn om de cache te resetten. Hierbij zullen de eerst volgende dataverzoeken vanuit Jane de meest de meest up-to-date informatie bij externe systemen opvragen."}>
    <div className={'flex flex-col gap-y-4'}>
      <ClearCache />
      {canManageAppPreferences && props.settings && <CacheTTL settings={props.settings} onUpdated={props.onUpdated}/>}
    </div>
  </SettingsContainer>
}

const ClearCache: FC = () => {
  const { cache } = useApiCall(config)
  const { showToast } = useToasts()
  const [isLoading, setIsLoading] = useState(false)

  const reset = (): void => {
    setIsLoading(true)
    cache.reset()
      .then(() => {
        showToast('Cache reset', "De cache is gereset.")
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return <Card title={'Applicatie cache'}>
    <Button disabled={isLoading} size={'sm'} type={"primary"} onClick={reset} text={'Reset cache'} />
  </Card>
}

const CacheTTL: FC<{ settings: SettingMap, onUpdated?: () => Promise<void> }> = (props) => {
  const { showToast } = useToasts()
  const { settings: settingsApi } = useApiCall(config)
  const [cacheTTL, setCacheTTL] = useState<number>(props.settings.api_cache_ttl ?? 0)

  const save = async () => {
    await settingsApi.update({
      api_cache_ttl: cacheTTL
    }).then(() => {
      showToast('Opgeslagen', "Uw wijzigingen zijn opgeslagen.")
    }).catch(() => {
      showToast('Oeps', 'Er is iets misgegaan bij het bewerken.')
    })
    await props.onUpdated?.()
  }

  return <Card title={'Api Cache TTL'}>

    <div className={'flex flex-col gap-y-4'}>
      <div className={'text-sm text-brand-secondary'}>
        Cache TTL (Time To Live) bepaalt hoe lang gegevens in de cache worden bewaard voordat ze automatisch worden vernieuwd. Je kunt de TTL zelf instellen.
        Een langere TTL zorgt ervoor dat gegevens minder vaak opnieuw worden opgehaald, wat de prestaties kan verbeteren.
        Een kortere TTL zorgt ervoor dat wijzigingen sneller zichtbaar zijn, maar kan leiden tot meer verzoeken.
      </div>
      <div className={'flex flex-row gap-x-4 items-center'}>
        <Input label={''} type={'number'} value={cacheTTL} onChange={setCacheTTL} min={0} />
        <div className={'text-sm text-brand-secondary'}>seconden</div>
      </div>
      <Button disabled={props.settings.api_cache_ttl === cacheTTL} size={'sm'} type={"primary"} onClick={save} text={'Opslaan'} />
    </div>
  </Card>
}